import React, { useState } from 'react';

function Permissions({ showToast }) {
  const [showModal, setShowModal] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'

  const [roles, setRoles] = useState([
    {
      id: 1,
      code: 'ADMIN',
      name: 'Quản trị viên',
      description: 'Toàn quyền truy cập và quản lý hệ thống',
      permissions: {
        dashboard: { view: true, edit: true, delete: true },
        alerts: { view: true, edit: true, delete: true },
        users: { view: true, edit: true, delete: true },
        branches: { view: true, edit: true, delete: true },
        positions: { view: true, edit: true, delete: true },
        permissions: { view: true, edit: true, delete: true },
        customers: { view: true, edit: true, delete: true },
        customerGroups: { view: true, edit: true, delete: true },
        models: { view: true, edit: true, delete: true },
        indicators: { view: true, edit: true, delete: true },
        workflows: { view: true, edit: true, delete: true },
        reports: { view: true, edit: true, delete: true }
      },
      userCount: 2,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 2,
      code: 'MANAGER',
      name: 'Quản lý',
      description: 'Quản lý nghiệp vụ và phê duyệt cảnh báo',
      permissions: {
        dashboard: { view: true, edit: false, delete: false },
        alerts: { view: true, edit: true, delete: false },
        users: { view: true, edit: false, delete: false },
        branches: { view: true, edit: false, delete: false },
        positions: { view: true, edit: false, delete: false },
        permissions: { view: true, edit: false, delete: false },
        customers: { view: true, edit: true, delete: false },
        customerGroups: { view: true, edit: true, delete: false },
        models: { view: true, edit: false, delete: false },
        indicators: { view: true, edit: false, delete: false },
        workflows: { view: true, edit: true, delete: false },
        reports: { view: true, edit: false, delete: false }
      },
      userCount: 5,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 3,
      code: 'ANALYST',
      name: 'Chuyên viên phân tích',
      description: 'Phân tích rủi ro và xử lý cảnh báo',
      permissions: {
        dashboard: { view: true, edit: false, delete: false },
        alerts: { view: true, edit: true, delete: false },
        users: { view: false, edit: false, delete: false },
        branches: { view: true, edit: false, delete: false },
        positions: { view: false, edit: false, delete: false },
        permissions: { view: false, edit: false, delete: false },
        customers: { view: true, edit: true, delete: false },
        customerGroups: { view: true, edit: false, delete: false },
        models: { view: true, edit: false, delete: false },
        indicators: { view: true, edit: false, delete: false },
        workflows: { view: true, edit: false, delete: false },
        reports: { view: true, edit: true, delete: false }
      },
      userCount: 8,
      status: 'Hoạt động',
      createdDate: '15/01/2026'
    },
    {
      id: 4,
      code: 'VIEWER',
      name: 'Người xem',
      description: 'Chỉ xem thông tin, không chỉnh sửa',
      permissions: {
        dashboard: { view: true, edit: false, delete: false },
        alerts: { view: true, edit: false, delete: false },
        users: { view: false, edit: false, delete: false },
        branches: { view: true, edit: false, delete: false },
        positions: { view: false, edit: false, delete: false },
        permissions: { view: false, edit: false, delete: false },
        customers: { view: true, edit: false, delete: false },
        customerGroups: { view: true, edit: false, delete: false },
        models: { view: true, edit: false, delete: false },
        indicators: { view: true, edit: false, delete: false },
        workflows: { view: true, edit: false, delete: false },
        reports: { view: true, edit: false, delete: false }
      },
      userCount: 3,
      status: 'Hoạt động',
      createdDate: '20/01/2026'
    }
  ]);

  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    permissions: {
      dashboard: { view: false, edit: false, delete: false },
      alerts: { view: false, edit: false, delete: false },
      users: { view: false, edit: false, delete: false },
      branches: { view: false, edit: false, delete: false },
      positions: { view: false, edit: false, delete: false },
      permissions: { view: false, edit: false, delete: false },
      customers: { view: false, edit: false, delete: false },
      customerGroups: { view: false, edit: false, delete: false },
      models: { view: false, edit: false, delete: false },
      indicators: { view: false, edit: false, delete: false },
      workflows: { view: false, edit: false, delete: false },
      reports: { view: false, edit: false, delete: false }
    }
  });

  const modules = [
    { key: 'dashboard', label: 'Dashboard', icon: 'bi-speedometer2' },
    { key: 'alerts', label: 'Cảnh báo', icon: 'bi-exclamation-triangle' },
    { key: 'customers', label: 'Khách hàng', icon: 'bi-person-circle' },
    { key: 'customerGroups', label: 'Nhóm khách hàng', icon: 'bi-people-fill' },
    { key: 'users', label: 'Người dùng', icon: 'bi-people' },
    { key: 'branches', label: 'Chi nhánh', icon: 'bi-building' },
    { key: 'positions', label: 'Vị trí', icon: 'bi-person-badge' },
    { key: 'permissions', label: 'Phân quyền', icon: 'bi-shield-check' },
    { key: 'models', label: 'Mô hình', icon: 'bi-diagram-3' },
    { key: 'indicators', label: 'Chỉ tiêu', icon: 'bi-bar-chart' },
    { key: 'workflows', label: 'Quy trình', icon: 'bi-diagram-2' },
    { key: 'reports', label: 'Báo cáo', icon: 'bi-file-earmark-bar-graph' }
  ];

  const filteredRoles = roles.filter(role => {
    const matchesSearch = role.name.toLowerCase().includes(searchText.toLowerCase()) ||
      role.code.toLowerCase().includes(searchText.toLowerCase());
    const matchesStatus = !statusFilter || role.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePermissionChange = (module, action) => {
    setFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [module]: {
          ...prev.permissions[module],
          [action]: !prev.permissions[module][action]
        }
      }
    }));
  };

  const selectAllPermissions = (module) => {
    setFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [module]: { view: true, edit: true, delete: true }
      }
    }));
  };

  const deselectAllPermissions = (module) => {
    setFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [module]: { view: false, edit: false, delete: false }
      }
    }));
  };

  const openCreateModal = () => {
    setEditingRole(null);
    setFormData({
      code: '',
      name: '',
      description: '',
      permissions: {
        dashboard: { view: false, edit: false, delete: false },
        alerts: { view: false, edit: false, delete: false },
        users: { view: false, edit: false, delete: false },
        branches: { view: false, edit: false, delete: false },
        positions: { view: false, edit: false, delete: false },
        permissions: { view: false, edit: false, delete: false },
        customers: { view: false, edit: false, delete: false },
        customerGroups: { view: false, edit: false, delete: false },
        models: { view: false, edit: false, delete: false },
        indicators: { view: false, edit: false, delete: false },
        workflows: { view: false, edit: false, delete: false },
        reports: { view: false, edit: false, delete: false }
      }
    });
    setShowModal(true);
  };

  const openEditModal = (role) => {
    setEditingRole(role);
    setFormData({
      code: role.code,
      name: role.name,
      description: role.description,
      permissions: JSON.parse(JSON.stringify(role.permissions))
    });
    setShowModal(true);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (!formData.code || !formData.name) {
      showToast('Vui lòng điền đầy đủ thông tin', 'warning');
      return;
    }

    if (editingRole) {
      setRoles(roles.map(role =>
        role.id === editingRole.id
          ? { ...role, ...formData }
          : role
      ));
      showToast('Đã cập nhật vai trò thành công', 'success');
    } else {
      const newRole = {
        id: roles.length > 0 ? Math.max(...roles.map(r => r.id)) + 1 : 1,
        ...formData,
        userCount: 0,
        status: 'Hoạt động',
        createdDate: new Date().toLocaleDateString('vi-VN')
      };
      setRoles([...roles, newRole]);
      showToast('Đã tạo vai trò mới thành công', 'success');
    }

    setShowModal(false);
  };

  const deleteRole = (roleId) => {
    const role = roles.find(r => r.id === roleId);
    if (role.userCount > 0) {
      showToast('Không thể xóa vai trò đang có người dùng', 'warning');
      return;
    }
    if (window.confirm('Bạn có chắc chắn muốn xóa vai trò này?')) {
      setRoles(roles.filter(role => role.id !== roleId));
      showToast('Đã xóa vai trò thành công', 'success');
    }
  };

  const toggleStatus = (roleId) => {
    setRoles(roles.map(role =>
      role.id === roleId
        ? { ...role, status: role.status === 'Hoạt động' ? 'Không hoạt động' : 'Hoạt động' }
        : role
    ));
    showToast('Đã cập nhật trạng thái', 'success');
  };

  const getPermissionBadge = (permissions) => {
    const total = Object.keys(permissions).length * 3;
    const granted = Object.values(permissions).reduce((sum, perm) => {
      return sum + (perm.view ? 1 : 0) + (perm.edit ? 1 : 0) + (perm.delete ? 1 : 0);
    }, 0);
    const percentage = Math.round((granted / total) * 100);
    
    if (percentage === 100) return { class: 'success', text: 'Toàn quyền' };
    if (percentage >= 70) return { class: 'primary', text: 'Cao' };
    if (percentage >= 40) return { class: 'warning', text: 'Trung bình' };
    return { class: 'secondary', text: 'Hạn chế' };
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <i className="bi bi-shield-check me-2"></i>
              Quản lý Phân quyền
            </h2>
            <p className="text-muted mb-0">Quản lý vai trò và phân quyền truy cập hệ thống</p>
          </div>
          <button className="btn btn-primary" onClick={openCreateModal}>
            <i className="bi bi-plus-circle me-1"></i>
            Tạo vai trò mới
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Tìm kiếm theo tên, mã vai trò..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Tất cả trạng thái</option>
                <option value="Hoạt động">Hoạt động</option>
                <option value="Không hoạt động">Không hoạt động</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => {
                  setSearchText('');
                  setStatusFilter('');
                  showToast('Đã xóa bộ lọc', 'info');
                }}
              >
                <i className="bi bi-x-circle"></i> Xóa lọc
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="row mb-3">
        <div className="col-md-3">
          <div className="card border-left-primary">
            <div className="card-body">
              <div className="text-primary font-weight-bold mb-1">Tổng vai trò</div>
              <div className="h5 mb-0">{roles.length}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-success">
            <div className="card-body">
              <div className="text-success font-weight-bold mb-1">Đang hoạt động</div>
              <div className="h5 mb-0">{roles.filter(r => r.status === 'Hoạt động').length}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-info">
            <div className="card-body">
              <div className="text-info font-weight-bold mb-1">Tổng người dùng</div>
              <div className="h5 mb-0">{roles.reduce((sum, r) => sum + r.userCount, 0)}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-warning">
            <div className="card-body">
              <div className="text-warning font-weight-bold mb-1">Vai trò hệ thống</div>
              <div className="h5 mb-0">4</div>
            </div>
          </div>
        </div>
      </div>

      {/* Roles Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Mã vai trò</th>
                  <th>Tên vai trò</th>
                  <th>Mô tả</th>
                  <th>Cấp quyền</th>
                  <th>Người dùng</th>
                  <th>Trạng thái</th>
                  <th>Ngày tạo</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredRoles.length > 0 ? (
                  filteredRoles.map((role) => {
                    const badge = getPermissionBadge(role.permissions);
                    return (
                      <tr key={role.id}>
                        <td><strong>{role.code}</strong></td>
                        <td>{role.name}</td>
                        <td><small className="text-muted">{role.description}</small></td>
                        <td>
                          <span className={`badge bg-${badge.class}`}>
                            {badge.text}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-info">{role.userCount} người</span>
                        </td>
                        <td>
                          <span
                            className={`badge bg-${role.status === 'Hoạt động' ? 'success' : 'secondary'}`}
                            onClick={() => toggleStatus(role.id)}
                            style={{ cursor: 'pointer' }}
                            title="Click để thay đổi trạng thái"
                          >
                            {role.status}
                          </span>
                        </td>
                        <td><small>{role.createdDate}</small></td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={() => openEditModal(role)}
                            title="Chỉnh sửa"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deleteRole(role.id)}
                            title="Xóa"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      <i className="bi bi-inbox fs-1"></i>
                      <p className="mt-2">Không tìm thấy vai trò nào</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingRole ? 'Chỉnh sửa vai trò' : 'Tạo vai trò mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSave}>
                <div className="modal-body">
                  <div className="row g-3 mb-4">
                    <div className="col-md-4">
                      <label className="form-label">Mã vai trò <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="code"
                        className="form-control"
                        value={formData.code}
                        onChange={handleInputChange}
                        placeholder="VD: MANAGER"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Tên vai trò <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="VD: Quản lý"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Mô tả</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Mô tả vai trò"
                      />
                    </div>
                  </div>

                  <h6 className="mb-3">Cấu hình quyền truy cập</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: '30%' }}>Module</th>
                          <th className="text-center">Xem</th>
                          <th className="text-center">Sửa</th>
                          <th className="text-center">Xóa</th>
                          <th className="text-center">Thao tác</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modules.map(module => (
                          <tr key={module.key}>
                            <td>
                              <i className={`bi ${module.icon} me-2`}></i>
                              {module.label}
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formData.permissions[module.key].view}
                                onChange={() => handlePermissionChange(module.key, 'view')}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formData.permissions[module.key].edit}
                                onChange={() => handlePermissionChange(module.key, 'edit')}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formData.permissions[module.key].delete}
                                onChange={() => handlePermissionChange(module.key, 'delete')}
                              />
                            </td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-success me-1"
                                onClick={() => selectAllPermissions(module.key)}
                              >
                                Chọn tất cả
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => deselectAllPermissions(module.key)}
                              >
                                Bỏ chọn
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-2"></i>
                    {editingRole ? 'Cập nhật' : 'Tạo mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Permissions;
